import React from 'react';
import Popover from '@material-ui/core/Popover';
import { popoverZIndex } from '../../constants';

function index(props) {
  return (
    <Popover
      style={{ zIndex: popoverZIndex }}
      open={props.open}
      anchorEl={props.elRefRen.current}
      onClose={props.handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      {props.children}
    </Popover>
  );
}

export default index;
